import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { getValidationErrorMessage } from "../utils";
import { RoutesMap } from "../../../../../routes.tsx";
import { usePinFormState } from "./usePinFormState.ts";
import { useNewAuthorization } from "../../useNewAuthorization";
import { EPinState } from "../../../../../store/pinFormStore.ts";
import { usePersistStore } from "../../../../../store/persistStore.ts";
import { isNewAuthorization } from "../../../../../store/authorizationStore";
import { useAddDeviceMutationReaction } from "./useAddDeviceMutationReaction.ts";
import { useAuthenticateDeviceMutationReaction } from "./useAuthenticateDeviceMutationReaction.ts";

export function usePinFormStateReaction() {
  useNewAuthorization("pin");
  const pinForm = usePinFormState();
  const persistStore = usePersistStore();
  const addDevice = useAddDeviceMutationReaction();
  const authDevice = useAuthenticateDeviceMutationReaction();
  const navigate = useNavigate();

  useEffect(() => {
    if (isNewAuthorization() && pinForm.state === EPinState.Validated) {
      return;
    }

    switch (pinForm.state) {
      case EPinState.Initial: {
        break;
      }
      case EPinState.Validating: {
        const errorMessage = getValidationErrorMessage(pinForm.pin);
        if (errorMessage) {
          pinForm.setState(EPinState.Initial);
          pinForm.setError(errorMessage);
          return;
        }
        pinForm.setState(EPinState.Validated);
        break;
      }
      case EPinState.Validated: {
        pinForm.setState(EPinState.Submitting);
        if (persistStore.deviceJWT) {
          authDevice.mutate({ pin: pinForm.pin, fingerprint: persistStore.fingerprint });
          return;
        } else {
          addDevice.mutate({ pin: pinForm.pin, fingerprint: persistStore.fingerprint });
          return;
        }
      }
      case EPinState.Submitted: {
        pinForm.reset();
        navigate(RoutesMap.index);
        // navigate(RoutesMap.login.loading,);
        return;
      }
    }
  }, [pinForm.state]);
}
